export default function auth ({ next, store  }){
    if(!store.state.user.user.data.verified){
        return next({
            name: 'user.setting.creator'
        })
    }
    return next()
}
